/**
 * The single place the platform split happens.
 *
 * Web resolves the palette through CSS variables so it can switch at runtime;
 * React Native (no `document`) keeps the literal values. Everything that needs
 * theme-reactive colors — the theme object, the approval primitives, any future
 * consumer — imports `colors` FROM HERE, so they all agree on web and none has
 * to know which platform it is on.
 *
 * The var() fallbacks are the dark literals, so a paint before the variable
 * stylesheet is injected (and every React Native paint) matches today's app.
 */
import { colors as literalColors, type Colors } from './colors';
import { cssVarColors } from './cssVars';

export const colors: Colors = typeof document !== 'undefined' ? cssVarColors : literalColors;
